<template src="./FormulariosTerapias.html"></template>

<script>
import DatePicker from "../../DatePicker/Datepicker";
export default {
  data() {
    return {
      deshabilitado: true,
      arrayNumeros: [],
      reglasObligatorio: [(v) => !!v || "Campo obligatorio"],
      padding: "2% 3% 2% 3%",
      cantidaElementosMostrar: 0,
    };
  },
  props: {
    variablesFormularios: {
      type: Object,
      default: {},
    },
  },
  methods: {
    calcularNumeros(valorMayor, valorMenor) {
      for (let i = valorMenor; i <= valorMayor; i++) {
        this.arrayNumeros.push(i.toString());
      }
    },
  },
  components: {
    DatePicker,
  },
  created() {},
};
</script>

<style lang="scss" scoped src="./FormulariosTerapias.scss">
</style>


// WEBPACK FOOTER //
// src/components/Terapias/FormulariosTerapias/FormulariosTerapias.vue